import { render, staticRenderFns } from "./ProductVariantsDialog.vue?vue&type=template&id=754ca201"
import script from "./ProductVariantsDialog.vue?vue&type=script&lang=js"
export * from "./ProductVariantsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports